import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import request from '../../../../Helpers/API';
import { LoaderScreen } from '../../../components/LoaderScreen';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from "@mui/lab";

export const TimelineModal = ({ open, handleClose, idcliente }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const [timelineCliente, setTimelineCliente] = useState();

    // console.log(timelineCliente)

    useEffect(() => {
        if (idcliente) {  // Solo ejecuta si idcliente tiene un valor válido
            request
                .get(`TimelineEventos/Timeline?idcliente=${idcliente}`)
                .then((result) => {
                    setTimelineCliente(result);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("TIMELINE", JSON.stringify(error), "error");
                });
        }
    }, [idcliente]); 


    return (
        <Modal open={open}>
            <div className="timeline-modal">
                <LoaderScreen loader={loader} />
                <div className="timeline-modal-title">
                    <h3>TIMELINE</h3>
                    <button className="cerrar-button" onClick={handleClose}>X</button>
                </div>
                <div className="timeline-modal-soy-el-titulo-line">
                    <div className="timeline-modal-soy-el-titulo-line-bl"></div>
                    <div className="timeline-modal-soy-el-titulo-line-circle"></div>
                    <div className="timeline-modal-soy-el-titulo-line-br"></div>
                </div>
                <div className='timeline-container'>
                    {timelineCliente && (
                        <div className="detalle-juridico-menu-right-timeline-cliente">
                            <Timeline>
                                {timelineCliente.map((evento, index) => {

                                const isMostRecent = evento === timelineCliente[timelineCliente.length - 1];

                                    return (
                                        <TimelineItem key={index}>
                                            <TimelineOppositeContent color="text.secondary">
                                                {evento.fecha}
                                            </TimelineOppositeContent>
                                            <TimelineSeparator>
                                                <TimelineDot color={isMostRecent ? "success" : "grey"} />
                                                {index < timelineCliente.length - 1 && <TimelineConnector />}
                                            </TimelineSeparator>
                                            <TimelineContent>
                                                <strong>{`${capitalizeWords(evento.empleado)}`}</strong>
                                                <br/>
                                                {`${capitalizeWords(evento.comentarios)}`}
                                            </TimelineContent>
                                        </TimelineItem>
                                    );
                                })}
                            </Timeline>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    )
};